export default __webpack_public_path__ + "static/media/dobri_m.5048e019.jpg";